const TRANSLATION = {
  buyModal: {
    afterFree: 'Након ваше пробне верзије',
    btn: 'Пробајте бесплатно',
    freeTrial: '3-дневни бесплатни пробни период',
    monthLabel: 'месец',
    selectLabel: 'Izaberite plan',
    title: 'План претплате',
    yearLabel: 'година',
  },
  contact: {
    block1:
      'Za prilagođavanje, pitanja ili predloge, molimo kontaktirajte nas na adresi contact@noam.tools. Brzo ćemo odgovoriti.',
    block2: 'Podržite nas ocenjujući nas u prodavnici Google Apps Extension sa ★★★★★.',
    block3: 'Pomozite drugima podelom ove ekstenzije:',
    title: 'Контактирајте нас',
  },
  help: {
    AquickOverviewOfNoam: 'Брзи преглед о Ноаму',
    ChatPDF: 'Чат ПДФ',
    ChatPDF2: 'ЧатПДФ',
    FavoritesManagement: 'Управљање омиљеним',
    Fixedplugin: 'Исправљена додатка',
    Focusing: 'Фокусирање',
    Free: 'Безплатно',
    FreeTrialBenefits: 'Prednosti besplatnog probnog perioda',
    GoWithWikipedia: 'Идите са Википедијом',
    GoWithYouTube: 'Иди са YouTube-ом',
    HoverTranslation: 'Превод при прегледању',
    Howtouse: 'Како користити',
    ImageTranslation: 'Превођење слика',
    InstantTranslation: 'Инстантно превођење',
    Membership: 'Чланство',
    NoamHelp: 'Ноам вам помаже да преведете и суздајете',
    PDFparallelTranslation: 'Паралелно превођење PDF-а',
    ParallelTranslation: 'Паралелно превођење',
    SkipAllSteps: 'Preskoči sve korake',
    Summary: 'Сажетак',
    Translation: 'Превод',
    TryItForFree: 'Пробајте бесплатно',
    Video: 'Видео',
    VideoSummary: 'Сажетак видеа',
    VideoTranslation: 'Превод видео снимка',
    WebSummary: 'Веб Сажетак',
    WordSelectionTranslation: 'Превод избор речи',
    benefits: 'Imamo pogodnosti koje vam čekaju!',
    dayFree: '3-дневни бесплатни пробни период',
    done: 'Готово',
    next: 'Следеће',
    pin: 'Закрепите Ноама за лакши приступ～～',
    planIsNotExist: 'План није доступан',
    startWiki: 'Почнемо са Викимедијом!',
    startYoutube: 'Počnimo sa YouTube-om!',
    try: 'Пробајте то',
    tryNow: 'Покушајте сада!',
  },
  home: {
    PDFTranslate: {
      desc: 'Двјезична превођења + ћаt PDF',
      sub1: {
        desc: 'Дvojeзично читање вам омогућава да поредујеш оригинални текст и превод страна по страни, побољшавајући ефикасност читања.',
        title: 'Двјезично читање',
      },
      sub2: {
        desc: 'AI analizira i sažima, kao i može da odgovori na vaše pitanja na osnovu sadržaja PDF-a.',
        title: 'Чат ПДФ',
      },
      sub3: {
        desc: 'Превођење PDF-а подржано вештачким интелигенцијом за већћу тачност и ефикасност.',
        title: 'Тачност и ефикасност',
      },
      title: 'Превод PDF-а',
    },
    aiAssistant: {
      desc: 'Čineći web prevod pametnijim i pogodnijim',
      panel1: {
        desc: 'Двујезичне прелазне преводе помоћу којег можете поредити оригинални текст са преводом, како бисте боље разумили и пожељно повећали ефикасност читања.',
        title: 'Двујезично превођење',
      },
      panel2: {
        left: {
          desc: 'Kada pregledate web stranicu, postavite miša preko sadržaja koji trebate prevesti da biste videli prevod.',
          title: 'Превод при лепљењу',
        },
        right: {
          desc: 'Prilikom pregledanja web stranice, izaberite tekst koji želite prevesti da biste videli prevod.',
          title: 'Превођење изабраног текста',
        },
      },
      panel3: {
        one: {
          desc: 'Преводите и сумирајте веб странице и видео садржај било када, било где, за глаткији искуство!',
          title: 'Кликни и изабери',
        },
        three: {
          desc: 'Велики језички модел управљен вештачким интелигенцијом обезбеђује тачност и конзистентност превода за побољшано искуство читања.',
          title: 'Vođeno umetnom inteligencijom',
        },
        two: {
          desc: 'Пуно покриће са више језика, двјезично читање без баријера, превођење са једним кликом - искуствујте разлику!',
          title: 'Још компрехензиван и удобан',
        },
      },
      panel4: {
        tab1: {
          desc: 'Vaš stručnjak za efikasnost - Noam koristi ChatGPT da prevodi i sažima sadržaj YouTube videoa kako bi vam uštedio vrijeme!',
          key: 'Видео',
          title: 'Превод и самаркаси видео',
        },
        tab2: {
          desc: 'Кликните да преведете слике приликом прегледања веб-сајта.',
          key: 'Слика',
          title: 'Превод слике',
        },
        tab3: {
          desc: 'Brzo izdvaja ključne informacije sa web stranica i pruža sažetak, povećavajući vašu efikasnost čitanja.',
          key: 'Веб',
          title: 'Веб Превод и Сажетак',
        },
        tag1: 'Једноставно',
        tag2: 'Ефикасан',
        tag3: 'Лако разумљиво',
      },
      title: 'АИ Асистент',
    },
    getStart: 'Почни',
    getStartedForFree: 'Започните без платежа',
    howItWork: {
      desc: 'Noam интегрише моделе вештачке интелигенције да пружи корисницима интелигентно искуство у превођењу и сужавanju веб-страница између језика, превођењу PDF-ова и слика, као и превођењу и сужавanju видео снимка',
      title: 'Како функционише',
    },
    lastBlock: { desc: 'Bolje AI prevođenje za glatkiji iskustvo čitanja' },
    top: {
      desc: 'Noam је бесплатна AI додатак за прегледач који вам помаже да преводите и изводите сажетке са веб страница, видео снимка и PDF садржаја.\nПридружите се Noam-у и искуствујте магију!',
      title1: 'Једна магија',
      title2: 'Једно кликање',
    },
    userReviews: {
      desc: 'Петозвездне рецензии у продавници Chrome веб-апликација',
      title: 'Корисничке оценје',
    },
  },
  installTips: {
    btn: 'Пробајте сада',
    text: 'Instalirajte „Noam Browser Plugin“ da biste otključali više funkcija! Preklapanje veb sadržaja,\n    sažetak veb videozapisa i još mnogo toga!',
  },
  locale: {
    af: 'африкаанс',
    am: 'амхарски',
    ar: 'арапски',
    as: 'асамски',
    auto: 'Автоматско детекцију',
    az: 'азербејџански',
    ba: 'башкир',
    bg: 'бугарски',
    bn: 'бангла',
    bo: 'tibetanski',
    bs: 'Босански',
    ca: 'каталонски',
    cs: 'Чешки',
    cy: 'Велшки',
    da: 'дански',
    de: 'Njemački',
    dsb: 'Dolnji sorbski',
    dv: 'дивехи',
    el: 'грчки',
    en: 'Енглески',
    es: 'španski',
    et: 'екстонски',
    eu: ' Баски',
    fa: 'персијски',
    fi: 'фински',
    fil: 'Filipinac',
    fj: 'фиџијански',
    fr: ' Француски',
    frCA: ' француски (Канада)',
    ga: 'Ирски',
    gl: 'галицијски',
    gom: 'конкани',
    gu: 'гуџарати',
    ha: 'хауса',
    he: 'hebrejski',
    hi: 'Хинди',
    hr: 'Хрватски',
    hsb: 'Горњи сорбски',
    ht: 'ajtsko kreolski',
    hu: 'мађарски',
    hy: 'арменски',
    id: 'индонезски',
    ig: 'Игбо',
    ikt: 'Инуинактун',
    is: 'Islandski',
    it: ' Италијански',
    iu: 'инуктитут',
    iuLatn: 'инуктитут (латиница)',
    ja: 'Јапански',
    ka: 'Грузин',
    kk: 'Казах',
    km: 'хмерски',
    kmr: 'Курдски (северни)',
    kn: 'Каннада',
    ko: 'корејски',
    ku: 'курдски (централни)',
    ky: 'киргиски',
    ln: 'Лингала',
    lo: 'Лао',
    lt: 'литвански',
    lug: 'Ганда',
    lv: 'latvijski',
    lzh: 'Кинески (литерарни)',
    mai: 'Мајтили',
    mg: 'малгашки',
    mi: 'Маори',
    mk: 'македонски',
    ml: 'малаялам',
    mnCyrl: 'монголски (ћирилица)',
    mnMong: 'Монголски (традиционални)',
    mr: 'маратхи',
    ms: 'малайски',
    mt: 'малтезски',
    mww: 'Хмонг Дау',
    my: 'Мијанмар (бирмански)',
    nb: 'норвешки',
    ne: 'непалски',
    nl: 'Холандски',
    noSearchLang: 'Језик није подржан',
    nso: 'Сесото са Лебоа',
    nya: 'њанја',
    or: 'Одија',
    otq: 'Керетаро Отоми',
    pa: 'панджабијски',
    pl: 'poljski',
    placeholder: 'Претрага',
    prs: 'Дари',
    ps: 'пашто',
    pt: 'португалски (Бразил)',
    ptPT: 'португалски (Португал)',
    ro: 'румунски',
    ru: 'руски',
    run: 'Руанда',
    rw: 'кињаруанда',
    sd: 'синди',
    si: 'синхалски',
    sk: 'словачки',
    sl: 'словеначки',
    sm: 'самоански',
    sn: 'Шона',
    so: 'Сомалија',
    sq: 'Албанца',
    srCyrl: 'српски (ћирилица)',
    srLatn: 'Српски (ћирилица)',
    st: 'сесото',
    sv: 'шведски',
    sw: 'свахилијски',
    ta: 'тамилски',
    te: 'телугу',
    th: 'Тајландски',
    ti: 'тигриња',
    tk: 'Туркмен',
    tlhLatn: 'Клингон',
    tlhPiqd: 'Клингон (pIqaD)',
    tn: 'Сетсвана',
    to: 'тонгански',
    tr: 'turski',
    tt: 'Татар',
    ty: 'тајтијански',
    ug: 'Ујгур',
    uk: 'українски',
    ur: 'урду',
    uz: 'Узбек (латиница)',
    vi: 'Vijetnamski',
    xh: 'Хоса',
    yo: 'Јоруба',
    yua: 'јукатек маја',
    yue: 'кантонски (традиционални)',
    zh: 'Кинески',
    zhHans: 'Кинески са једноставним писмом',
    zhHant: 'Кинески традиционални',
    zu: 'Зулу',
  },
  login: {
    and: 'и',
    btn: 'Пријава преко Гугла',
    btn1: 'Пријавите се сада',
    desc: 'Пријавите се да бисте открili више искустава',
    policy: 'Политика приватности',
    terms: 'Услови коришћења',
    tips: 'Претплатом се согласим са',
    title: 'Добро дошли у Ноам',
  },
  pageFooter: {
    follow: { facebook: 'Фејсбук', title: 'Прати', twitter: 'Твитер' },
    legal: { policy: 'Политика приватности', terms: 'Услови кориштења', title: 'Правни' },
    product: {
      image: 'Превод слике',
      pdf: 'Превођење PDF-a',
      title: 'Производи',
      video: 'Превођење и саммари видео записа',
      web: 'Веб превод и сумаризација',
    },
    resources: { title: 'Ресурси' },
    tools: { title: 'Алати', pdf: 'Превод PDF-a' },
  },
  pageHeader: {
    contact: 'Контакт',
    help: 'Помоћ',
    logout: 'Одјава',
    logoutSucc: 'Одјављени сте.',
    pricing: 'Cene',
    settings: 'Поставке',
    signUp: 'Пријава',
  },
  pdf: {
    autoDetect: 'Аутоматско детекцију',
    cancelBtn: 'Откажи',
    cancelUpload: 'Откажи',
    chatPdf: {
      summaryError: 'Сажетак није успео, молимо покушајте поново касније',
      chatError: 'Чат није успео, молимо покушајте касније поново',
      Search: 'Претрага',
      cancel: 'Откажи',
      chatTitle: 'Добро дошли у Noam! Ово је садржајни преглед вашег PDF-a:',
      clear: 'Јасан',
      clearContent:
        'Ово ће започети нову разговор. Тренутни разговор неће бити сачуван. Да ли сте сигурни?',
      clearDialogTitle: 'Молимо потврдите',
      clearSucc: 'Очишћено',
      copy: 'Копирај',
      copySucc: 'Копирано',
      delete: 'Обриши',
      deleteCancel: 'Откажи',
      deleteContent: 'Ovaj PDF ne može se povratiti nakon brisanja. Jeste li sigurni?',
      deleteOk: 'Обриши',
      deleteSuccess: 'Obrišano',
      deleteTitle: 'Потврди брисање',
      expand: 'Kolaps',
      historyTitle: 'Историја',
      listError:
        'Неуспело учитавање листе за читање. Покушајте поново касније или контактирајте подршку.',
      loading: 'Учитавање...',
      noDataDesc: 'Још нема историје.',
      noMore: 'Нема више садржаја.',
      placeholder: 'Питајте било шта о овом PDF-u',
      summaryTitle: 'Možda ćete biti zainteresovani ovim pitanjima:',
    },
    collectionEmpty: 'Ваша колекција је празна.',
    collectionTab: 'Белешке',
    dataLoading: 'Учитавање...',
    dialogContent: 'Јesi ли сигуран/сигурна да желите да обришете ово?',
    dialogTitle: 'Молимо потврдите',
    download: {
      both: 'двјезично',
      btn: 'Сачувај',
      cancel:
        'Затварање овог прозора ће отказати преузимање PDF-а. Да ли сте сигурни да желите да отказате?',
      desc: 'Сачувај на уређај: Преузима преводе као слике; Сачувај и штампај: Преузима преводе у оригиналном формату, са подршком за копирање.',
      download: 'Преузми',
      downloadMsg1: 'Napredak prevoda PDF-a:',
      downloadMsg2: 'Procenjeno preostalo vreme:',
      downloadSucc: 'PDF је спреман! Кликните да сачувате.',
      downloadTip:
        'Преузимање PDF-а. Не затварајте овај прозор како бисте избегли грешке при преузимању.',
      error: 'Čuvanje nije uspelo. Pokušajte umesto toga štampanje.',
      fileName: 'Име фајла:',
      fileType: 'Тип фајла:',
      loading: 'Чување...',
      loading2: 'Учитавање...',
      minute: 'Минути...',
      msg1: 'Neke prevode u ovom dokumentu su duži od originalnog teksta i mogu se preklapati u preuzetoj datoteci. Preporučujemo čitanje na veb stranici.',
      msg2: 'Превод још није довршен. Молимо преузмите након што се превод заврши.',
      msg3: '2. Neke prevode su preduge. Čitajte na web stranici kako biste izbegli preklapanje teksta.',
      msg4: 'Prevodilačke zadatke su u toku. Molimo pokušajte ponovo nakon što se završe.',
      progress:
        'Превођење PDF-а. Napredak: {{progress}}, Процењено преостало време: {{minutes}} минута...',
      save: 'Сачувај на уређај',
      savePrint: 'Сачувај и штампај',
      success: 'Преузето',
      trans: 'Само превођење',
      transContinue: 'Настави са превођењем',
    },
    downloadBtn: 'Преузми',
    dragTipModal: {
      black: 'пространство',
      leftKey: 'леви дугме',
      ok: 'Успјело',
      press: 'Притисни',
      tips: 'prevlačiti i pregledati',
    },
    entry: 'PDF-ови',
    fileErrMsg: 'Čitanje datoteke nije uspelo. Pokušajte ponovo kasnije ili kontaktirajte podršku.',
    fileMsg: 'Тренутна величина фајла:',
    fileMsg2: 'Молимо вас да отпремите фајл мањи од 300MB.',
    freeBannerBtn: 'Апгрейд',
    freeBannerTips: 'Достигнут лимит бесплатних превода PDF-a',
    guide: {
      placeholder: 'Залепи линк за PDF овде',
      start: 'Почни превођење',
      text1: 'Билингвално читање',
      text2:
        'Čitajte dvojezično kako biste uporedili originalni tekst i prevod jedan pored drugog, povećavajući vašu efikasnost.',
      text3: 'Разговор са вашим PDF-ом',
      text4:
        'Анализа и сумаризација подржана ИИ-ем. postavљајте питања о вашем PDF-у и добијате инстантне одговоре.',
      text5: 'Тачан и ефикасан',
      text6: 'Prevođenje PDF-a uz podršku umetne inteligencije za veću tačnost i efikasnost.',
      title1: 'Билингвална превод',
      title2: 'Разговор са вашим PDF-ом',
      toast: 'Унесите исправан онлайн PDF линк који завршава са .pdf',
    },
    hasTransTask: 'Prevod je u toku. Molimo sačekajte.',
    hoverTrans: 'Пасуса са превођењем при завишењу',
    initial: 'Превод PDF',
    installText: 'Ваше једноставно решење за свадневне преводе.',
    installText2: 'Prvo instalirajte ekstenziju',
    installTips:
      'Инсталирајте додатак за још више превода PDF датотека и слатније преводе веб сајтова:',
    kw: 'кључна',
    link: 'линк',
    listError:
      'Неуспело учитавање PDF-ова. Молимо покушајте поново касније или контактирајте подршку.',
    memoTotalCount: 'укупно 1 ставка',
    new: 'нови фајл',
    noId: 'Идентификатор фајла није пронађен.',
    notPdf: 'Само PDF фајлови.',
    okBtn: 'Избриши',
    okBtn2: 'Успјело',
    original:
      'Јасте високо тачан и pouzdan AI dizajniran да генерише JSON излаз који се потпуно слаже са специфираном JSON шемом.\n\nМорате пратити ове правила:\n1. С雷耀но се придружавати структури JSON шеме.\n2. Тачно подударати све врсте података, обавезна поља и ограничења.\n3. НЕ УКЛАЈУЈТЕ никакве додатни текст, објашњење, маркдаун или коментаре.\n4. ИЗЛАЗИТЕ САМО JSON објекат — без блокова кода, без претекста, без обвивки.\n\nИнформације о шеми су наведене испод.\n- Име шеме: translate_result\n- JSON Schema:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    parallel: 'Паралелан',
    parseErrDialogContent:
      'Овај линк за PDF не може бити директно prevedен. Молимо Вас да преузмете PDF и отпреглате га за превођење.',
    parseErrTips: 'Неуспело парсирање фајла',
    parseFileToast:
      'Неуспело парсирање фајла. Молимо покушајте поново касније или контактирајте подршку.',
    pdfLoading: 'Објашњавање...',
    searchPlaceholder: 'Претрага',
    selectTrans: 'Изаберите текст за превођење',
    shareBtn: 'Дељење',
    shareBtnText1: 'Генериши везу за дељење',
    shareBtnText2: 'Ажурирај дељени садржај',
    shareModal: {
      cancel: 'Откажи',
      copy: 'Копирај',
      copySucc: 'Линк копиран',
      custom: 'Прилагодите:',
      errMsg: 'Izabrani sadržaj još nije potpuno preveden. Pre prikazivanja molimo prevedite ga.',
      gen: 'Деље',
      modify: 'Уреди',
      notSupport: 'Овај језик тренутно није подржан.',
      page: 'Странице',
      pageNuErr: 'Унесите исправан број странице.',
      range: 'Opseg:',
      remain: 'preostalo',
      remain1: 'Ukupno procenjeno vreme:',
      search: 'Претрага',
      settings: 'Поставке дељења:',
      shareSetting: 'Подешавања дељења',
      shareText: 'Деље',
      shareTips: 'Podelite link prevedenog PDF-a sa svojim prijateljima:',
      sourceLang: 'Од:',
      target: 'За:',
      text1: 'Поставке дељења',
      text2: 'Генериши линк за дељење',
      totalPage: 'укупно 1 страница',
      trans: 'Преведите',
      translateTips:
        'Савет: Ако превод траје дуго, можете затворити овај прозор и поделити се касније.',
      translating: 'Превођење PDF-а...',
      update: 'Ажурирај везу дељења',
    },
    shareMsg1: 'Генерисан линк за дељење.',
    shareMsg2: 'Дељени садржај ажуриран.',
    shareMsg3:
      'Неуспело је генерисање везе за дељење. Покушајте поново касније или контактирајте подршку.',
    shareMsg4:
      'Неуспело ажурирање дељеног садржаја. Молимо покушајте поново касније или контактирајте подршку.',
    shareTips: 'Ваша превођења PDF документа је спремна! Дељете је са пријатељима.',
    start: 'Пočnite са бесплатном пробном верзијом',
    thumbnail: 'Садржај',
    toast1: 'Учитавање PDF-а. Молимо покушајте поново касније.',
    toast2: 'PDF sadržaj se obrađuje. Dialog trenutno nije podržan.',
    toast3: 'Преузимање. Покушајте поново након што се преузимање заврши.',
    toolbar: { Adjust: 'Промijeniti', autoFit: 'Ауто-прилагођавање' },
    trans: 'Превод',
    transSucc: 'Превод uspješan!',
    unLoginToast: 'Молимо пријавите се да бисте користили ову функцију.',
    uploadBtn: 'Уплоад',
    uploadErr:
      'Уплоад фајла није успео. Молимо покушајте поново касније или контактирајте подршку.',
    uploadErrSignUrl:
      'Неуспело је добавање URL-а за отпремање. Молимо покушајте поново касније или контактирајте подршку.',
    uploadMsg1: 'Превуците и пусните фајл овде.',
    uploadMsg2: 'Подржани формати фајлова: PDF  |  Максимална величина фајла: 300MB',
    uploadMsg3: 'Кликните да бисте изабrali или повуците и пусните фајлове овде.',
    uploading: 'Постављање',
    uploadingMsg: 'Постављање. Молимо сачекајте.',
    uploadingMsg1: 'Datoteka se postavlja na server. Pokušajte ponovo kasnije.',
    uploadingMsg2: 'Datoteka se trenutno konvertuje. Pokušajte ponovo kasnije.',
    uploadingMsg3:
      'Zahtev za napredak konverzije nije uspeo. Molimo pokušajte ponovo kasnije ili kontaktirajte podršku.',
    uploadingMsg4:
      'Noam ne može pristupiti lokalnim datotekama. Molimo ručno postavite PDF datoteku za prevođenje.',
    uploadingMsg5:
      'Неуспело да се изврати URL датотеке. Покушајте поново касније или контактирајте подршку.',
    video: 'видео',
    vipBannerBtn: 'Анаджирање',
    vipBannerTips: 'Достигли сте лимит превођења PDF-а за ове године.',
    webTrans: 'Пуно умешђено референцирање',
  },
  pricing: {
    FAQ: 'ČPP',
    FQAObj: {
      a1: 'Да, Noam нуди бесплатан план који можете користити одмах.',
      a2: 'Pružamo tri plana članstva: Pro, Pro+ i Enterprise. Možete odabrati mesečnu ili godišnju plaćanje. Godišnje naplaćivanje nudi značajne uštede.',
      a3: 'Sve funkcije su dostupne u oba paketa. Glavna razlika je cena: godišnje pretplate ukupno koštaju manje. Mesečne pretplate se naplaćuju svakog meseca, dok se godišnja paketa naplaćuju jednom godišnje.',
      a4: 'Можете да откаžete своју претплату било када у поставкама налога.',
      q1: 'Postoji li besplatan plan?',
      q2: 'Koja cena paketa i opcije plaćanja su dostupni?',
      q3: 'Koja je razlika između mesečne i godišnje pretplate?',
      q4: 'Kako otkazujem svoj pretplatu?',
    },
    around: 'oko',
    billedMonthly: 'Фактурирање месечно',
    billedYearly: 'Наплаћује се годишње',
    day: 'дан',
    desc: 'Упоредите планове и изберите најбољи',
    detailedCompare: 'Упоређи планове',
    discount: '20% попуст',
    enterprise: {
      benefit1: 'Приоритетна подршка клијентима',
      benefit2: 'Множе корисници',
      benefit3: 'Прилагодљена решења',
      benefit5: 'Посвећени менаџер налога',
      btn: 'Контактирајте нас',
      recommendText: 'Прилагођени планови (≥3 особе)',
      talkToUs: 'Kontaktirajte nas',
    },
    free: {
      benefit1: 'Instantna prevodjenja 100 puta dnevno',
      benefit2: 'Превођење и резиме веб сајта',
      benefit3: '30 превода слика',
      benefit4: 'Превод и самаршена видео снимка',
      benefit5: '10 PDF превода',
      benefit6: '5.000 токена',
      btn: 'Пробајте бесплатно',
      recommendText: 'Бесплатно пробно коришћење',
    },
    imageTranslation: 'Превођење слика',
    month: 'месец',
    monthly: 'Месечно',
    pageTitle: 'Cene',
    pdf: {
      chat: 'Питања за чат са PDF-ом',
      maxPage: 'Макс. страница по PDF-у',
      translation: 'Превод PDF-а',
    },
    preMonth: 'Po mesecu',
    pro: {
      benefit1: 'Приоритетна подршка корисницима',
      benefit2: '1.000.000 tokena/mesec',
      benefit3: 'Превођење и сумирање веб-сајта',
      benefit4: '200 Превода слика',
      benefit5: 'Превод и резиме видео снимка',
      benefit6: '200 превода PDF-ова',
      btn: 'Почни',
      recommendText: 'Најпопуларнији',
    },
    proPlus: {
      benefit1: 'Приоритетна подршка корисницима',
      benefit2: '3.000.000 токена/месец',
      benefit3: 'Превод и резиме веб сајта',
      benefit4: '500 Превода Слика',
      benefit5: 'Превод и резиме видео снимка',
      benefit6: '500 PDF превода',
      recommendText: 'Najbolja vrednost',
    },
    video: { summary: 'Сажетак видеа', translation: 'Превод видео снимка' },
    web: {
      contrastiveTranslation: 'Билингвална Превод',
      dictionaryTranslation: 'Избор превођења',
      hoverTranslation: 'Превод при завишевању',
      instantTranslation: 'Моментална превод',
      summary: 'Сажетак веб-странице',
    },
    yearly: 'Годишњи',
  },
  privacy: {
    block1:
      'Ноам ("Ноам", "ми", "наш" или "нам") поштује вашу приватност и обавезан је заштити сваку информацију коју добијамо од вас или о вама. Ова Политика приватности описује наших практика у погледу прикупљања или коришћења личних информација при коришћењу нашег веб сајта, апликација и услуга ( заједно, "Услуге"). Ова Политика приватности не примењује се на садржај који обрађујемо у име наших пословних клијената, као што је наш API. Коришћење ових података зависи од нашег договор са клијентима, који обухвата приступ и коришћење ових производа.',
    block10:
      'Primenjujemo komercijalno razumne tehničke, administrativne i organizacione mere za zaštitu online i offline ličnih podataka od gubitka, neovlašćenog korišćenja, pristupa, otkrivanja, izmenjivanja ili neprijateljskih akcija. Međutim, nijedna internet ili email transmisija ne može garantirati potpunu sigurnost ili tačnost. Konkretno, emailovi poslate nam ili od nas možda nisu sigurni. Stoga trebate biti posebno oprezni kada odlučujete koja informacija ćete nam poslati putem usluge ili emaila. Dodatno, nismo odgovorni za bilo kakvo ometanje podešavanja privatnosti ili sigurnosnih mera u usluzi ili sigurnosnih podešavanja ili mera trećih strana na veb-sajtima. Čuvaćemo vaše lične podatke sve dok je potrebno da vam pružimo usluge ili za druge zakonite poslovne svrhe, kao što su rešavanje sporova, razlozi sigurnosti i bezbednosti ili poštivanje naših pravnih obaveza. Vreme čuvanja ličnih podataka zavisiće od mnogih faktora, kao što su količina, priroda, osjetljivost informacija, potencijalni rizici neovlašćenog korišćenja ili otkrivanja, svrhe za koje obrađujemo informacije i druge pravno obavezujuće razmatranja.',
    block11:
      'Možemo da ažuriramo ovu Politiku privatnosti s vremena na vreme. Kada to učinimo, objaviti ćemo ažuriranu verziju na ovoj stranici, osim ako to primenjeno pravo ne zahteva drugačije.',
    block12:
      'Ако имате нерешењена питања или забрињавања у вези са овом Политиком приватности, молимо контактирајте наш сервис за клијенте. Е-маил:',
    block2: 'Скупујемо следеће личне информације („Личне информације“) које се односе на вас:',
    block3:
      'Информације које сте пружили: Приликом креирања налога за коришћење наших услуга или комуникације са нама, прикупљамо личне информације на следећи начин:',
    block4:
      'Лично податке који се аутоматски примају при коришћењу услуга: Када приступајете, користите или комуницирате са услугама, примиоћемо следеће информације о вашем приступу, коришћењу или комуникацији („технички подаци“):',
    block5: 'Možemo koristiti lične podatke u sledeće svrhe:',
    block6:
      'Сажетак или обезличене информације: Можемо да агрегирамо или обезличимо личне информације како бисмо спречили њихово поновно коришћење за сврхе идентификације и користити такве информације за анализу ефикасности наших услуга, побољшање и додавање функција на наше услуге, спровођење истраживања и за сличне сврхе. Пored тога, можемо да анализирамо опште понашање и карактеристике корисника наших услуга и деље агрегиране информације са трећим странама, објављујемо такве агрегиране информације или чинимо их опште доступним. Можемо да сакупљамо агрегиране информације преко услуга, преко колачића и преко других средстава описаних у овој Политици приватности. Обрађујамо и користимо обезличене информације у анонимној или обезличеној форми и нећемо покушавати да их поново идентификујемо осим ако је то прописано законом.',
    block7:
      'У одређеним случајевима, можемо доставити ваше личне податке трећим странама без додатног обавјештења вам, осим ако закон то забрани:',
    block8:
      'U zavisnosti od vaše geografske lokacije, pojedinci u Evropskom ekonomskom prostoru, Ujedinjenom Kraljevstvu i globalno mogu imati određena zakonska prava u vezi sa svojim ličnim podacima. Na primer, možete imati pravo da:',
    block9:
      'Услуга може садржати везе ка другим веб-сајтовима који се не управљају или не контролишу компанијом Noam, укључујући услуге друштвених медија („Веб-сајтови треће стране“). Информације које дељете са веб-сајтовима треће стране регулишеће специфична правила о приватности и услови услуге тих веб-сајтова треће стране, а не ова Полиса о приватности. Ове везе пружајемо ради удобства и то не подразумева наше препоручивање или преглед ових веб-сајтова. За информације о њиховим политикама приватности и условима, молимо директно да контактирате веб-сајтове треће стране.',
    subBlock1:
      'Информације о налогу: Када креирате налог на нашој платформи, прикупљамо информације повезане са вашим налогом, укључујући vaše име, контактне информације, креденцијале налога, информације о платежној карти и историјат трансакција ("Информације о налогу").',
    subBlock10: 'Опремања, управљање, одржавање и/или анализа услуга;',
    subBlock11: 'Komuniciranje sa tobom',
    subBlock12: 'Развој нових производа и услуга;',
    subBlock13:
      ' sprečavanje prevaranja, krivičnih dela ili zlonamene upotrebe naših usluga, kao i zaštita bezbednosti naših IT sistema, arhitekture i mreža;',
    subBlock14: 'Проводња трансфера послова;',
    subBlock15:
      'Савршавањем правних обавеза и правних postupaka, заштитивањем наших права, приватности, безбедности или имovine, као и оних наших придружених предузећа, вас или других трећих страна.',
    subBlock16:
      'Dobavljači i pružaoci usluga: Da bi nam pomogli da zadovoljimo potrebe poslovne operacije i obavimo određene usluge i funkcije, možemo pružati lične podatke dobavljačima i pružaocima usluga, uključujući pružače hosting usluga, pružače cloud usluga, druge pružače informacionih tehnologija, softver za elektronsku poštu i pružače usluga web analitike itd. Ovi partneri će pristupati, obrađivati ili čuvati lične podatke samo prema našoj uputi prilikom obavljanja svojih dužnosti za nas.',
    subBlock17:
      'Преноси послова: Ако се укључимо у стратешке трансакције, реорганизације, банкротстве, преузимања у банкротству или прелаз услуга на другог провајдера ( заједно „Трансакције“), ваше лично и друго информације могу бити поделjene са контрагентима трансакција и другим странама које помажу у Трансакцијама током процедуре прилагођавања и пренете као део Трансакција заједно са другим активIMA на наследника или придружено друштво.',
    subBlock18:
      'Законски захтеви: Можемо поделити ваше лично информације са владиним органима, пословним партнерима или другим трећим странама, укључујући информације о вашем интеракцији са нашим услугама, (1) ако то захтева закон или ако верујемо да је такакво дело неопходно за спустање законских обавеза; (2) да заштитимо и одбранимо наше права или имovina; (3) ако унаilateralно одредимо да постоји прекршење наших услова, политика или закона; (4) да откријемо или спречavimo обмана или друге незаконе активности; (5) да заштитимо naše производе, запослене или кориснике, или јавну безбедност, сигурност, интегритет; или (vi) да се одбранимо од правног одговорности.',
    subBlock19: 'Приступите вашим личним подацима и подацима о томе како се они обрађују.',
    subBlock2:
      'Kada koristite naše usluge, prikupljamo lične podatke iz vaših unosa, postavljanja datoteka ili povratnih informacija koje nam pružate ("Sadržaj").',
    subBlock20: 'Захтев за брисање ваших личних информација из наших записи',
    subBlock21: 'Исправите или ажурирајте ваше личне информације.',
    subBlock22: 'Пребаците ваше личне информације трећој страни ( преносивост података ).',
    subBlock23: 'Ограничите како обрађујемо ваше личне податке.',
    subBlock24:
      'У повлачење приговора — где се ослађујемо на пристанак као правну основу за обраду, можете повући свој пристанак у било ком тренутку.',
    subBlock25: 'Prilogujte se načinu na koji obrađujemo vaše lične podatke.',
    subBlock26: 'Unapređivanje naših usluga i provođenje istraživanja;',
    subBlock3:
      'Информације о комуникацији: Ако нам шаљете поруке, прикупћемо ваше име, контактне информације и садржај ваших порука („Информације о комуникацији“).',
    subBlock4:
      'Информације о друштвеним медијима: Имамо странице на веб сајтовима друштвених медија као што су Instagram, Facebook, Medium, Twitter, YouTube и LinkedIn. Када сарадujete са нашим страницама друштвених медија, прикупљамо личне информације које нам изаберете да доставите, као што су ваши контакт подаци („Друштвене информације“). Пored тога, компаније које домаће наше странице друштвених медија можда ће нам доставити агрегиране информације и анализе о нашим активностима на друштвеним медијима.',
    subBlock5:
      'Лог података: Информације које аутоматски шаље ваш прегледач при коришћењу наших услуга. Лог података укључује вашу Интернет Протокол (IP) адресу, тип и подешавања прегледача, датум и време ваших захтева, као и начин на који интерактујете са нашом веб страницом.',
    subBlock6:
      'Подаци о коришћењу: Можемо аутоматски сакупљати информације о вашем коришћењу услуге, као што су врсте садржаја које гледате или са којима комуницирате, функције које користите, акције које спроводите, као и ваша временска зона, држава, датум и време приступа, кориснички агент и верзија, тип рачунара или мобилног уређаја и ваше повезивање рачунара.',
    subBlock7:
      'Информације о уређају: Ово укључује назив уређаја, оперативни систем, идентификатор уређаја и веб-прегледач који користите. Прикупљена информација може зависити од врсте уређаја који користите и његових поставки.',
    subBlock8:
      'Кукије: Користимо кукије да би управљали и уређивали наше услуге и побољшали ваше искуство. „Кукија“ је информација коју веб-сајт који посећате шаље вашем прегледачу. Можете подесити свој прегледач да прихвати све кукије, одбије све кукије или вас обавести када се понуди кукија, како бисте могли одлучитити да ли ћете је прихватити сваки пут. Међутим, одбијање кукија може спречити вам коришћење или негативно утицати на приказ или функционалност одређених делова или карактеристика веб-сајта. За више информација о кукијама, посетите All About Cookies.',
    subBlock9:
      'Аналитика: Можемо користити разне онлајн аналитичке продукте који користе колачиће да би нам помогли да проанализирамо како корисници користе наше услуге и побољшамо ваше искуство при кориштењу услуга.',
    subTitle1: 'Лично податке које прикупљамо',
    subTitle2: 'Како користимо личне информације',
    subTitle3: 'Откривање личних информација',
    subTitle4: 'Ваши права',
    subTitle5: 'Везе ка другим веб сајтовима',
    subTitle6: 'Sigurnost i čuvanje informacija',
    subTitle7: 'Измена Политике приватности',
    subTitle8: 'Како да контактирате нас',
    title: 'Политика приватности',
    updateTime: 'Ажурирано: 15. марта 2024.',
  },
  privacyCollectionPanel: {
    acceptBtn: 'Прихвати све',
    text: 'Da bismo poboljšali vaše iskustvo, koristimo kolačiće za personalizaciju sadržaja i usluga.',
    title: 'Овај сајт користи колачиће',
  },
  slogen: 'Најлакши АИ асистент',
  stripe: {
    contact: 'Контактирајте нас на адресу contact@noam.tools са било којим питањима!',
    fail: {
      btn: 'Покушај поново',
      text1: 'Nismo mogli da obrađamo vašu uplatu.',
      text2: 'Проверите ваше повезивање и покушајте поново.',
      title: 'Плаћање није успело',
    },
    succ: {
      btn: 'Хајде да идемо',
      text1: 'Добродошли у Ноам',
      text2: 'Почнимо!',
      title: 'Честитамо',
    },
  },
  terms: {
    block1: 'Хвала што користите Noam!',
    block10:
      '(а) Тарифе и фактурирање. Мораћете платити све тарифе („Тарифе“) према ценошку и условима на одговарајућој страни са ценошком или како је договорено у писму између нас. Задржавамо право да исправимо грешке у ценошком или грешке чак и ако смо издали фактуре или примили плаћање. Мораћете обезбедити потпуну и тачну фактурирачку информацију, укључујући важећи и овлашћени начин плаћања. Платити ћемо на ваш начин плаћања периодично, како је договорено, али можемо разумно променити датум фактурирања. Овлашћавате Noam, његове афилјате и треће стране за обраду плаћања да наплаћују на ваш начин плаћања. Ако ваше плаћање не успје,ћемо вам послати писмену обавјештење и можемо приуставити приступ услузи док се не прими плаћање. Осим ако није другачије прописано у овом договору, плаћања нису враћања.',
    block11:
      '(б) Порези. Осим у супротном наведеног, цене не укључују никаке савезне, државне, локалне и иностранске порезе, обавезе и сличне накнаде („Порези“). Ви сте одговорни за све Порезе повезане са вашим куповима, искључујући Порезе засноване на нашом чистом приходу за које ћемо вам исплатити фактуру. Слаžete се да брзо платите такве Порезе и да нам доставите законски важеће изјаве о приватности и добијете неопходна писмена сагласност за обраду таквих података, а гарантујете нам да обрађујете такве податке у складу са применимом законом.',
    block12:
      '(в) Промене цена. Можеmo да промените наше цене обавештавањем вас преко вашег налога и/или наше веб-странице. Пovisјења цена ће ступити на снагу одмах након објављивања. Sve промене цена ће се применити на таксове за ваш налог након датума ступања на снагу промене.',
    block13:
      '(d) Spori i neiskorišćeni plaćanja. Ako želite da osporite bilo koje naknade ili poreze, molimo da se javite na contact@noam.tools unutar trideset (30) dana od datuma računa.',
    block14:
      '(e) Бесплатна употреба. Не можете креирати више налога да бисте добили бесплатне кредите. Ако утврдимо да не користите бесплатне кредите искрено, можемо вас таксовати стандардним трошима или преуставити приступ Сервису.',
    block15:
      '(а) Повериљност. Можда ћете имати приступ повериљном информацијама Noam-а. Можете користити повериљне информације само онолико колико дозволено овим условима, и то са циљем коришћења Сервиса. Не можете раскривати повериљне информације никаком трећој strani, и мораћете заштитити повериљне информације на начин који није мање заштитни него начин на који заштитавате ваше сопствене сличне повериљне информације, најмање са разумном пажњом. Повериљне информације су информације које нису јавне, које Noam одређује као повериљне или које би разумно требало третати као повериљне у дати ситуацији, укључујући софтвер, спецификације и друге не јавне пословне информације. Повериљне информације не укључују информације које: (1) постану опште доступне јавности без вашег вина; (2) имате у вашем власништву без било какве обавезе повериљности пре приёма према овим условима; (3) законски вам раскрије трећа страна без било каквих обавеза повериљности; или (4) самостално развијате без коришћења повериљних информација. Можете раскривати повериљне информације ако то захтева закон, суд или други владин наредба, али мораћете доставити претходно писмену обавештење Noam-у на разуман начин и, што је могуће, урадити разумне напоре да ograničite опсег раскривања, укључујући помоћ нам у противовању захтевама за раскривање.',
    block16:
      '(б) Безбедност. Морате спровести разумне и одговарајуће мере да бисте заштитили приступ и коришћење Сервиса. Ако откријете какве било рањивости или порушења којима је повезано ваше коришћење Сервиса, морате без одлашка контактирати Ноама и пружајте детаље о рањивости или порушењу.',
    block17:
      '((в) Обрадња личних података. Ако користите Сервис за обраду личних података, морате обезбедити правно довољне изјаве о приватности и добити неопходна писмена согласања за обраду таквих података, а ми гарантујете да обрађујете такве податке у складу са примењуеним законским прописима.)',
    block18:
      '(а) Прекидање; Пристојање. Ови услови ће ступити на снагу од првог коришћења услуге иће валидни бити све док се не прекидају. Можете прекинути ове услове у било каком тренутку и због било којег разлога преустављањем коришћења услуге и садржаја. Ми можемо прекинути ове услове са претходном обавештењем због било којег разлога. Могућ је и одмах прекидање ових услова путем обавештења уколико сте материјално прекршили чланак 2 (Потребности за коришћење), чланак 5 (Конфиденцијалност, безбедност и заштита података), чланак 8 (Решење спорова) или чланак 9 (Општи услови), или уколико се промени наши однос са било којим трећим провајдером технологије над којим немамо контролу, или због прилагоде закону или захтевама владе. Можемо пристојити приступ услузи ако нескомплетирате ове услове, или ако ваше коришћење претставља ризик за безбедност за нас или било каког трећег лица, или ако осумњавамо да је ваше коришћење лажно или може изложити нас или било каког трећег лица одговорности.',
    block19:
      '(б) Ефекти прекида. При прекиду, престанете да користите Услугу и брзо вратите или унистите било какву тајну информацију како нам наредимо. Одредба овог Уговора које су природно трајајуће после прекида или истеклице, укључујући али не ограничевајући се Одсецима 3 и 5-9,ће остати важеће.',
    block2:
      'Овие Условија коришћења важе за коришћење услуга Noam-а, укључујући наше интерфејсе за програмирање апликација, софтвер, алате, услуге за програмери, податке, документацију и веб сајт (зайедно називане „Услуге“). Коришћењем наших Услуга, сагласни сте да се придржавате ових услова. Наша Политика приватности објашњава како прикупљамо и користимо личне информације.',
    block20:
      '(а) Обезбеђење од одговорности. Ја ћете заштити, обезбедити од одговорности и држати нас, наших придружених предузећа и наших радника неповређених од било каквих тврђења, губитака и трошкова (укључујући адвокатске цене) који произлазе из или су повезани са вашим коришћењем Сервиса, укључујући ваше садржаје, ваше коришћење производа или услуга повезаних са Сервисом и ваше штетење ових услова или применимог закона.',
    block21:
      '(б) Отрицања одговорности. Сервис се пружа „као што је“. У опsegu дозволеном законом, ми, наши афилјати и лицензатори не дајемо никакав облик представстава или гаранција у вези са Сервисом и не дајемо гаранције, укључујући али не ограничивајући се гаранцијама тржишне продажности, пригодности за посебну сврху, задовољавајуће квалитете, неповређивања права и мирног коришћења, као и било које гаранције које произлазе из трговачког односа или обрасца трговине. Не гарантујемо да ће Сервис бити непрекидан, тачан или без грешака, или да ће било који садржај бити сигуран, не изгубљен или не промењен.',
    block22:
      '(в) Ограничење одговорности. Ни ми, ни наши придружени друштва, ни наши лицензатори неће бити одговорни за какве год недељиве, случајне, посебне, последичне или казнене штете, укључујући губитак профита, губитак репутације, губитак коришћења, губитак података или друге нематеријalne губитке, чак и ако смо били упозорени на могућност таквих штета. Према овим условима, наша укупна одговорност неће прелазити износ плата које сте платили за Сервис у протеклих дванаест (12) месеци пре подношења тражбе или сто америчких долара ($100), у зависности шта је веће. Ограничења у овој секцији важе у највећој мери дозвољено законом који важи.',
    block23:
      'Uslovi korišćenja i vaše korišćenje Usluga regulišu se zakonima Sjedinjenih Država, osim pravila o sukobu zakona SAD. Vaše korišćenje Aplikacije takođe može biti podložno drugim lokalnim, saveznim, nacionalnim ili međunarodnim zakonima. Bilo koja pravna akcija ili postupak u vezi sa ovim Uslovima podignut će se isključivo pred sudovima Sjedinjenih Država, a vi se slažete da se podvrgnete ličnom jurisdikciji takvih sudova.',
    block24:
      'Однос страна. Ноам и ви сте независни субизадате, и ниједна страна нема моћ да представља или обврзује другу страну или преузима обавезе у име друге стране без претходног писменог сагласја друге стране.',
    block25:
      '(б) Коришћење бренда. Нисте овлашћени да користите име, лого или трговске ознаке компаније Noam или било којег њеног придруженој предузећа без нашег претходног писменог одобренја.',
    block26:
      'Ако се било која одредба ових услова утврди као неважећа, не zakonita или не спроводива, остале одредбе ће остати у потпуној снази и ступњу важења.',
    block3:
      'Ако имате мање од 18 година, морате добити дозволу од својих родитеља или законских представника да користите Сервис. Ако користите Сервис у име друге особе или ентитета, морате бити овлашћени да прихватите ове услове у њихово име. При регистрацији налога морате обезбедити тачне и потпуне информације. Не можете пружајте ваше приступне креденцијале или налог никоме ван ваше организације, и носите одговорност за све активности извршене помоћу ваших креденцијала.',
    block4:
      '(а) Коришћење сервиса. Можете приступити сервису у складу са овим условима, а ми вам дајемо нефскузивно право на коришћење сервиса. При коришћењу сервиса, мораћете се придружавати овим условима и свим применименим законима. Ми и наши афилјативи поседујемо све права, наслове и интересе у сервису.',
    block5:
      '(б) Обратна информација. Добродошли су нам обратне информације, коментари, идеје, предлози и унапређења. Ако доставите какву такву садржај, можемо га користити без каквих ограничења и без компензације за вас.',
    block6:
      '(в) Ограничења. Нисте овлашћени да: (1) користите Сервис на начин који крши, апропријативно или штети било којим правима других лица; (2) обврatimо инжењерство, декомпајлирајте, растављате, преводите или на други начин покушавате да откријете изворни код или основне компоненте модела, алгоритама и система Сервиса (осим ако применимо закон забрањује таква ограничења); (3) користите излаз Сервиса за развој модела који конкурирају Noam-у; (4) извлачите податке или излаз из Сервиса користећи било које аутоматизоване или програмерске методе осим ако то није дозвољено преко API-а, укључујући скрејпинг, веб хевестирање или веб извлачење података; (5) представљате излаз Сервиса као вештачки генерисан када није такав, или на други начин кршите наше правила коришћења; (6) купујете, продајете или преносите API кључеве без наше претходне согласе; или (7) нам достављате било какве личне информације деце млађе од 13 година или применимог возраста за цифралну согласност. Љутим ћете се свих ограничења на брзину и других захтева из наших документација.',
    block7:
      '(d) Услуге треће стране. Сваки софтвер, услуга или други производи треће стране повезани са услугом регулишу се сопственим условима, а ми не носимо одговорност за производе треће стране.',
    block8:
      '(а) Ваш садржај. Можете обезјавити улазне податке („Улаз“) у Сервис и добити излазне податке („Излаз“) који се генеришу и враћају на основу Улаза ( заједно називане „Садржај“). Između страна, и у мери дозвољено применимом законодавства, ви власник сте свих Улаза. Noam може користити Садржај да обезбеди и одржи Сервис, придржава се применимог законодавства и спровodi naše правила. Vi ste одговорни за Садржај, укључујући осигурање да он не крши каквото било применимо законодавство или ове услове.',
    block9:
      '(б) Тачност. Вештачка интелигенција и машинско учење су брзо развијајућа подručја истраживања. Непрекидно покушавамо да побољшамо наш сервис како би био тачнији, поузданiji, сигурнији и кориснији. С обзиром на вероватноћни карактер машинског учења, коришћење нашег сервиса у одређеним случајевима може резултирати нетачним излазima, који можда не одражавају тачно стварне особе, места или чињенице. Требате одговарајуће проценити тачност било каквог излаза на основу вашег случаја коришћења, укључујући ручно прегледавање излаза.',
    subTitle1: 'Регистрација и приступ',
    subTitle10: 'Делимост',
    subTitle2: 'Услови коришћења',
    subTitle3: 'Садржај',
    subTitle4: 'Такси и плаћање',
    subTitle5: 'Поверилност, безбедност и заштита података',
    subTitle6: 'Трај и крај',
    subTitle7: 'Компензација; Изјава одбајања од одговорности; Ограничење одговорности',
    subTitle8: 'Правило које влада и надлежност',
    subTitle9: 'Општи услови',
    title: 'Услови кориштења',
    updateTime: 'Ажурирано: 15. март 2024.',
  },
  trialModal: {
    btn: 'Započnite sada (samo $0,99)',
    chat: 'ЧатПДФ',
    desc1: 'Nakon vašeg probnog perioda, naplaćiće se godišnja naknada od 180 dolara',
    desc2: 'Откажи било када',
    focus: 'Фокусирање',
    hover: 'Превод при зависању',
    image: 'Превођење слика',
    installBtn: 'Инсталирајте сада да бисте получили свој поклон',
    memo: 'Управљање омиљенима',
    pdf: 'Паралелно превођење PDF',
    realtime: 'Инстантна превођења',
    select: 'Превод изборa речи',
    title: 'Добродошли поклон',
    trialText: '7-дневни пробни период',
    video: 'Превођење видео снимка',
    videoSummary: 'Сажетак видео записа',
    web: 'Паралелно превођење',
    webSummary: 'Сажетак веб странице',
  },
  upgradeModal: {
    btn: 'Ажурирајте сада',
    chat: {
      free: 'Достигли сте лимит ChatPDF-а',
      pro: 'Достигли сте лимит ChatPDF-а за овај месец',
    },
    contactStr:
      'Molimo sačekajte sledeći reset ili nas kontaktirajte na adresi contact@noam.tools.',
    limitAlertStr: ' Dosegli ste limit besplatnog plana. Nadogradite da nastavite.',
    more: 'Погледајте планове',
    pageLimit: { free: 'Достигли сте лимит страница PDF-а' },
    title: 'Потсетник',
    upgradeAlertStr: 'Достигли сте лимит бесплатног плана. Надоградите да наставите.',
    upload: {
      free: 'Достигли сте лимит превођења PDF фајлова',
      pro: 'Достигли сте лимит превођења PDF-а за овај месец',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'Придружите се сада',
      label: 'Prednosti novih korisnika:',
      remain: 'Оставило се само 30',
      text: 'Само 100 места доступно! Захватите своје сада!',
    },
  },
  aiPdfTranslator: {
    title: 'Бесплатни АИ преводилац ПДФ фајлова: Преводи ПДФ са поређењем на било који језик',
    desc: 'Лако преводите PDF фајлове на било који језик помоћу ИИ. Поређујте оригинални и prevedени текст једно поред другог, брзо и бесплатно.',
    keywords: 'GPT-4、АИ Асистент、Превођење、Сажетак、Фокус、ЧатПДФ、Белешка、ефикасност',
    sourceToTarget: {
      title: 'Бесплатно алат за превођење PDF-a: бесплатно преведите {{source}} на {{target}}',
      desc: 'Преведите ваше PDF фајлове са било ког изворног језика на ваши преференцирани језик бесплатно. Брзо, тачно и сигурно превођење PDF фајлова подржано напредном ИИ технологијом.',
    },
    headerIntroduce: {
      title: 'Ноам: више него само онлайн превођење',
      introduce1: {
        title: 'Ноам · PDF читач',
        desc: '✨Превод са поравнањем страна + AI питања и одговори. брзо и тачно преведајте PDF‑ове у ваш језик циља. слободно постављајте питања о садржају да бисте дубље разумели ваше PDF фајлове.',
      },
      introduce2: {
        title: 'Noam · Ekstenzija za prevod u paralelnom prikazu',
        desc: '👏Решите све ваше потребе за превођење веб-страница:',
        detail1: {
          title: 'Превођење веб-странице:',
          desc: 'Двок језички приказ једна поред другог',
        },
        detail2: { title: 'Превођење речи:', desc: 'Брзо превођење са једним кликом' },
        detail3: { title: 'Брзо превођење:', desc: 'Prevedite reči ili rečenice odmah.' },
        detail4: { title: 'Превођење слике:', desc: 'Замените слике преведеним тима.' },
        detail5: { title: 'Превод видеоа: ', desc: 'Двајезични титлови за боље гледање.' },
        footer: 'Испробајте више карактеристика читања подржаних ИИ за паметнију превођење!',
      },
    },
    subtitle: 'Превод PDF-а онлајн бесплатно',
    introduce: {
      module1: {
        detail1: {
          title: 'Realno-vremenska paralelna prevodjenja PDF-a',
          desc1:
            'Instantno prikazuje originalni i prevedeni sadržaj u sinhronizovanom rasporedu sa strane na stranu',
          desc2: 'Lako upoređujte obe verzije sa sinhronizovanim skrolovanjem',
          desc3: 'Одржавајте идентичан формат за конзистентно искуство читања',
        },
        detail2: {
          title: 'Тачан усавршавање и верификација садржаја',
          desc1: 'Savršeno poravnanje između izvornog i prevedenog teksta za laku verifikaciju',
          desc2: 'Svaki segment sadržaja se precizno podudara u oba verzija',
          desc3: 'Brzo prepoznajte i rešite neslaganja u prevodima za pouzdane rezultate',
        },
      },
      module2: {
        detail1: {
          title: 'Множење напредних АИ модела за прецизну превођење',
          desc1: 'Изберите међу водећим АИ моделима да бисте задоволили ваше потребе за превођењем',
          desc2: 'Осигурајте оптималне резултате за разне врсте докумената и индустrije',
          desc3: 'Флексибилне опције модела пружају прилагођена решења за сваки сценариј',
        },
        detail2: {
          title: 'Napredno AI prevođenje za svaki tip sadržaja',
          desc1: 'Наш моћан AI модел обезбеђује високу тачност и разумевање природног језика',
          desc2: 'Lako rukuje tehničkim, akademskim i kreativnim dokumentima',
          desc3: 'Dostavlja pouzdane rezultate za sve vaše potrebe za prevođenjem',
          desc4: 'Интелигентна адаптација на различите типове садржаја за оптималну перформансу',
        },
      },
      module3: {
        detail1: {
          title: 'Интелигентна интеракција са документима',
          desc1:
            'Lako komunicirajte sa svojim PDF datotekama i prezentacijama koristeći naprednu umjetnu inteligenciju',
          desc2: 'Моментално постављајте питања о садржају документа и добијате тачне одговоре',
          desc3: 'Брзо генеришите сжате резIME за дуге документе',
        },
        detail2: {
          title: 'Dubinska analiza sadržaja i nesmetana integracija',
          desc1:
            'Извучите кључне информације и анализирајте сложне податке са разумевањем омогућеним вештачким интелигенцијом',
          desc2: 'Dobijte uvid u tehničke, akademske ili kreativne materijale',
          desc3:
            'Bez problema se integracija sa našim prevodilacom PDF-a za potpunu rešenje za upravljanje dokumentima',
        },
      },
      module4: {
        detail1: {
          title: 'Izavan prevoda PDF-a: Sve u jedno rešenje za prevod web stranica',
          desc: 'Откријте наш моћан додатак за превођење са поравнањем страница, дизајниран за сваки сценариј онлајн читања.',
          desc1:
            'Превод веб-странице: Уживате у двјезичном садржају са синхронизованим прегледом са стране на страну',
          desc2: 'Превод речи: Истог тренутка преведите истакнуте речи једним кликом',
          desc3:
            'Безгарантно превођење: Преведите било који текст или реченицу тренутно за брзо разумевање',
          desc4: 'Превођење слика: Аутоматски замените оригиналне слике преведеним верзијама',
          desc5:
            'Превод видео снимка: Гледајте видео снимке са двјезичним титловима за побољшано искуство',
        },
      },
    },
    question: {
      title: 'Često postavljana pitanja',
      answer1: {
        title: 'Da li je Noam PDF Translator besplatan za prevod PDF datoteka?',
        content:
          'Да, можете бесплатно превести PDF датотеке помоћу Sider PDF Преводиоца! Пружамо бесплатни квота од 5.000 токена, што је довољно за превођење већине PDF докумената који се обично налазе на тржишту. Ако треба да преведете веће датотеке или вам је потребно напредне функције, можете изабрати да се надоградите на наше премијум плане за још више могућности.',
      },
      answer2: {
        title: 'Koliko je tačan prevodilac Noam PDF?',
        content:
          'Преводилац Noam PDF пружа изузетно тачне преводе користећи напредну AI технологију и дубоко разумејући контекст ваших докумената. Иако ниједан аутоматички превод није савршен, наш приказ страна по страни омогућава вам да лако прегледате и прерађујете сваки превод, осигурајући да коначни резултат испуњава ваше очекивања квалитета. Искуствујте поуздан и прецизан превод PDF докумената са Noam-ом.',
      },
      answer3: {
        title: 'Могу ли да преведем скениране PDF-ове?',
        content:
          'Да, можете превести скениране PDF датотеке помоћу нашег уграђеног OCR (Optical Character Recognition) технологије. Наш систем аутоматски извлачи текст из скенираних докумената и PDF-ова заснованих на сликама, а затим превећа садржај за вас. Ово обезбеђује да чак и неусавршавају или искључиво сликовни PDF-ови могу бити тачно преведени.',
      },
      answer4: {
        title: 'Koliko vremena traje prevod?',
        content:
          'Превод је брз и ефикасан — већина докумената се обрађује у року од неколико секунди до неколико минута, у зависности од њихове дужине и сложености. На пример, стандардни PDF са 10 страна обично траје мање од 2 минуте да се преведе. Уживате у брзом обрству за све ваше потребе превођења докумената!',
      },
      answer5: {
        title: 'Могу ли да задржим изглед са две стране за читање?',
        content:
          'Да, увек можете читати ваше документе једно поред другог. Овај изглед вам омогућава лако поређење оригиналног и преведеног садржаја, осигурајући гладко и ефикасно читање.',
      },
    },
    freeTrial: 'Бесплатни пробни период',
    toLanguage: { title: 'PDF AI парови за превод', item: '{{source}} у {{target}}' },
  },
  aiPdfTranslate: {
    header: {
      button: 'Преводи сада',
      features: ' Карактеристике',
      pricing: 'Cene',
      blog: 'Блог',
      faq: 'ČPP',
    },
    hero: {
      upload: {
        title: 'Прикачи свој PDF',
        highlight: 'Кликните за преглед',
        max: 'Макс',
        desc: 'ili prevucite i ispustite',
      },
      to: 'у',
      title: 'Бесплатни преводионик PDF-ова',
      pill: 'Преводионик PDF-a на базе вештачке интелигенције',
      desc: 'Instantne, tačne prevode koji čuvaju originalni raspored. Noam AI podržava OCR i prikaz strane po strani.',
      model: 'GPT-4 и Claude',
      support: 'Подршка за OCR',
      free: 'Бесплатна пробна верзија',
      translated: 'Преведено од стране Ноама',
      complete: 'Превод је завршен',
    },
    ticker: {
      pdf: 'Превођење PDF-а',
      ocr: 'OCR технологија',
      format: 'Задржавање формата',
      multi: 'Многојезично',
      web: 'Веб превод',
      side: 'Jedno pored drugog',
      chat: 'Разговор са PDF-ом',
      secure: 'Безбедно и приватно',
    },
    comparison: {
      bad: {
        title: 'Стандардни превод',
        head: 'Изгубљена форматирања и контекст',
        text1: 'Грешка: Лайаут је оштећен. Слике су погрешно постављене.',
        text2: 'Текст се преклапа и фонтови су несконзистентни. Тешко се чита и непрофесионално...',
      },
      dump: { title: 'Избацивање чистог текста' },
      good: {
        title: 'Noam AI Превод',
        sub: 'Савршено форматирање, свесно контекста',
        tag: 'Савршени Резултат',
      },
      title: 'Зашто изабрати Noam AI?',
      desc: 'Prestanite da se bore sa prevodom kopiraj-i-nalepi. Iskustite razliku između standardnih alata i našeg AI-om pogonjenog prevoda svestog konteksta.',
    },
    showcase: {
      title1: 'Bilo koji dokument',
      kicker: 'ПОДРЖАНИ ДОКУМЕНТИ',
      title2: 'Bilo koji jezik',
      carousel4: 'Медицина',
      carousel1: 'Умјетност',
      note: 'Lako rukovodite tehničkim, akademskim i kreativnim dokumentima.',
      carousel3: 'Академски часопис',
      carousel2: 'Архитектура',
      carousel6: 'Закон',
      carousel5: 'Финансије',
      carousel7: 'Уговор',
      carousel8: 'Политика',
    },
    features: {
      big: {
        title: 'Napredni modeli umele inteligencije (GPT-4, Claude)',
        desc: 'Изаберите из водећих АИ модела да бисте их прилагодили вашим захтевима за превођење. Осigurajte оптималне резултате за разне врсте докумената.',
      },
      grid1: {
        title: 'Подршка за OCR',
        desc: 'Извучите и преведите текст из сканиранih PDF-ова и слика инстантно.',
      },
      grid2: {
        title: 'ВисокOREZ извоз',
        desc: 'Preuzmite svoje prevedene dokumente u PDF formatu sa originalnim rasporedom.',
      },
      grid3: {
        title: 'Упоређивање једно по једно',
        desc: 'Sinkronizovano skrolovanje za poređenje originalnog i prevedenog teksta.',
      },
      title1: 'Više od samo prevoda',
      title2: 'То је револуција',
      line1: 'Технички рад.pdf',
      line2: 'Отклањање језика: енглески...',
      line3: 'Модел: GPT-4o (Висока прецизност)',
      line4: 'Превод Завршен (99% Тачност)',
    },
    testimonials: {
      review1: {
        role: 'Истраживач',
        content:
          'Noam AI mi je uštedio sate u prevodu naučnih radova. Prikaz sa strane po strani je nevjerovatno koristan za proveru tehničkih termina.',
      },
      review2: {
        role: 'Глобални маркетер',
        content:
          'Najbolji prevodilac PDF-a koji sam koristio. Savršeno čuva originalni formatiranje, što je ključno za naše marketinške prezentacije.',
      },
      review3: {
        role: 'Правни саветник',
        content:
          'Тачан и брз. Koristim га за преводе договора, а функција OCR за скениране докумената ради без грешака.',
      },
      title: 'Šta kažu naši korisnici',
      kicker: 'ОВЛАŠТАВА КОРИСНИЦИ',
    },
    cta: {
      title: 'Јесли сте спремни да превазиђете језичке баријере?',
      button: 'Почните превођење бесплатно',
      desc: 'Придружите се више од 10.000 корисника и почните преводити ваше документе са Noam AI данас.',
      hint: 'Vi ste visoko tačan i pouzdan AI dizajniran da generiše JSON izlaz koji se potpuno uklapa u specificirani JSON šemu.\n\nMorate pratiti ove pravila:\n1. Strogo se pridržavajte strukture JSON šeme.\n2. Tačno podudarajte sve tipove podataka, obavezna polja i ograničenja.\n3. NE uključujte nikakav dodatni tekst, objašnjenje, markdown ili komentare.\n4. Ispišite SAMO JSON objekat — bez blokova koda, bez preambule, bez obavijanja.\n\nInformacije o šemi su date ispod.\n- Naziv šeme: translate_result\n- JSON šema:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    },
    languagePairs: {
      title: 'Englesko PDF AI parovi prevoda',
      desc: 'Популарни смерови превођења које подржава Noam AI',
    },
    footer: { about: 'О нама', privacy: 'Политика приватности', contact: 'Контактирај подршку' },
  },
}

export default TRANSLATION
